import React from "react";
import "./Certifications.css";

import AWS_BADGE from "../../assets/images/apn.png";
import CKA_LOGO from "../../assets/images/cka_logo.png";
import CNCF_LOGO from "../../assets/images/CNCF.svg";
import KUBECON_LOGO from "../../assets/images/Kubecon_Horiz.svg";

const groups = [
  {
    title: "AWS",
    items: [
      {
        image: AWS_BADGE,
        name: "AWS Partner Network",
        detail: "Select Consulting Partner",
      },
      {
        monogram: "SA",
        name: "AWS Solutions Architect",
        detail: "Professional Level Certification",
      },
      {
        monogram: "DO",
        name: "AWS DevOps Engineer",
        detail: "Professional Level Certification",
      },
    ],
  },
  {
    title: "Kubernetes & Cloud Native",
    items: [
      {
        image: CKA_LOGO,
        name: "Certified Kubernetes Administrator",
        detail: "Linux Foundation Certification",
      },
      {
        image: CNCF_LOGO,
        name: "CNCF Member",
        detail: "Cloud Native Computing Foundation",
      },
      {
        image: KUBECON_LOGO,
        name: "KubeCon Participant",
        detail: "Annual Cloud Native Conference",
      },
    ],
  },
];

const Certifications = () => {
  return (
    <section id="certifications" className="section">
      <div className="container">
        <div className="section-head">
          <p className="eyebrow">credentials</p>
          <h2 className="h2">Certifications & partnerships</h2>
          <p className="lede">Industry-recognized expertise you can trust.</p>
        </div>
        <div className="cert-groups">
          {groups.map((group) => (
            <div className="cert-group" key={group.title}>
              <h3>{group.title}</h3>
              <div className="cert-list">
                {group.items.map((item) => (
                  <div className="card card-hover cert-item" key={item.name}>
                    <div className="cert-logo">
                      {item.image ? (
                        <img src={item.image} alt={item.name} loading="lazy" />
                      ) : (
                        <span className="cert-monogram">{item.monogram}</span>
                      )}
                    </div>
                    <div>
                      <strong>{item.name}</strong>
                      <span>{item.detail}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
